<div class="bar-menu d-flex align-items-center" (click)="tieredMenu.toggle($event)">
  <i class="icon-hamburgermenu bar-menu_icon"></i>
</div>
<p-tieredMenu #tieredMenu [model]="items" [popup]="true"
              styleClass="tiered-menu_big tiered-menu_from-right tiered-menu_open-content-to-left"
></p-tieredMenu>
